import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { HOUR, MINUTE } from "./constants";
import { getTimeFromMilliseconds } from "./utils";

const GoogleTagManager = () => {
  useEffect(() => {
    if (process.env.REACT_APP_GOOGLE_TAG) {
      TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG });
    }
  }, []);

  return null;
};

export default GoogleTagManager;

/**
 * @param {GTagEvent} params
 */
export function googleTagEvent({ event, category, label, action, value }) {
  if (process.env.REACT_APP_GOOGLE_TAG && window.dataLayer) {
    /** @type {GTagEvent} */
    const dataLayerEvent = { event };
    if (category) dataLayerEvent.category = category;
    if (label) dataLayerEvent.label = label;
    if (action) dataLayerEvent.action = action;
    if (value) dataLayerEvent.value = value;

    window.dataLayer.push(dataLayerEvent);
  }
}

/**
 * @param {Omit<GTagEvent, 'category'>} args
 */
export function googleTagPlayCategoryEvent({ event, label, action, value }) {
  googleTagEvent({ event, category: "Play-radio", label, action, value });
}

/**
 * @param {Omit<GTagEvent, 'category'>} args
 */
export function googleTagTimePlayingCategoryEvent({
  event,
  label,
  action,
  value,
}) {
  googleTagEvent({ event, category: "Play-time", label, action, value });
}

const GTAG_TIMES_INTERVAL = [3 * MINUTE, 10 * MINUTE, HOUR / 2, HOUR];

/** @type {number[]} */
let gtag_time_event_timeouts = [];

/**
 * @param {string} type
 */
export function startGTagEventsByPlayingTime(type) {
  stopGTagEventsByPlayingTime();

  gtag_time_event_timeouts = GTAG_TIMES_INTERVAL.map((time) =>
    setTimeout(() => {
      const minutesString = getTimeFromMilliseconds(time, {
        onlyMinutes: true,
      });
      googleTagTimePlayingCategoryEvent({
        event: `Playing ${minutesString} minutes`,
        label: `Playing ${type} radio`,
        action: "Play duration",
      });
    }, time),
  );
}

export function stopGTagEventsByPlayingTime() {
  gtag_time_event_timeouts.forEach(clearTimeout);
}
